import React, { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isMuted, setMuted } from "@/lib/sfx";

/**
 * Small floating mute toggle for the cursive tracing screens. Stays in sync
 * with any other `MusicToggle` instance via the `zl-audio-mute` window event
 * emitted by `sfx.setMuted()`.
 */
export function MusicToggle({ className = "" }) {
  const [muted, setLocalMuted] = useState(isMuted());

  useEffect(() => {
    const handler = (e) => setLocalMuted(!!e.detail?.muted);
    window.addEventListener("zl-audio-mute", handler);
    return () => window.removeEventListener("zl-audio-mute", handler);
  }, []);

  const toggle = () => setMuted(!muted);

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="cursive-music-toggle"
      aria-pressed={!muted}
      aria-label={muted ? "Turn background music on" : "Turn background music off"}
      title={muted ? "Turn music on" : "Turn music off"}
      className={`inline-flex items-center gap-1.5 rounded-full border-2 border-[#E5DECF] bg-white px-3 py-1.5 text-xs font-bold text-[#6B7280] transition-colors hover:border-[#0D9488] hover:text-[#0D9488] ${className}`}
    >
      {muted ? <VolumeX size={14} /> : <Volume2 size={14} />}
      <span>{muted ? "Music off" : "Music on"}</span>
    </button>
  );
}

export default MusicToggle;
